import { Component, Input, OnInit, Pipe, PipeTransform, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PublicService } from 'src/app/services/public.service';


@Pipe({ name: 'safeUserHtml'})
export class SafeUserHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  noteList= [];
  @Input()
  path : string;
  load = true;
  profile_url: string;
  blog_url: string;

 // constructor(private db : DatabaseService) { }
 constructor(private route: ActivatedRoute, private pService: PublicService) {}

  ngOnInit(): void {

  this.profile_url = this.route.snapshot.paramMap.get('profile_url');
  this.blog_url = this.route.snapshot.paramMap.get('blog_url');
  this.pService.readPost(this.profile_url+"-"+this.blog_url).subscribe((res)=>{
    if(res != "InValid"){
      this.noteList = res;
    }
  })

  }


  ngOnChanges(changes: SimpleChanges) {
    //this.pService.getPosts({"username":this.comment_data.username, "blog_url": this.comment_data.blog_url})
    this.profile_url = this.route.snapshot.paramMap.get('profile_url');
    this.blog_url = this.route.snapshot.paramMap.get('blog_url');
    this.pService.readPost(this.profile_url+"-"+this.blog_url).subscribe((res)=>{
      if(res != "InValid"){
        this.noteList = res;
      }
    })
}

}
